import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore} from "redux";
import { Provider } from "react-redux";
import rootReducer from "./modules";
import App from './components/App';


const devTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
const store = createStore(rootReducer, devTools);

ReactDOM.render(
    <Provider store={store}>
            <App></App>
    </Provider>, 
    document.getElementById('root'));

